import { createContext, useContext } from 'react';
import { defaultOpenFormSettings } from '../../constants';
import type { FormFunctionality } from '../../types';

interface FormPopupContextType {
  openPopup: () => void;
  closePopup: () => void;
  isPopupOpen: boolean;
  formSettings: FormFunctionality;
  onFormChange: () => void;
  onFormSubmit: () => void;
}

export const FormPopupContext = createContext<FormPopupContextType>({
  openPopup: () => {},
  closePopup: () => {},
  isPopupOpen: false,
  formSettings: defaultOpenFormSettings,
  onFormChange: () => {},
  onFormSubmit: () => {}
});

export const useFormPopup = () => {
  return useContext(FormPopupContext);
};
